"use client";
import { motion } from "framer-motion";

/* Renders soft, animated radial glow blobs across the page — pure CSS gradients. */
export default function ParticleBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" data-testid="particle-background">
      {/* Base grid */}
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="absolute inset-0 bg-radial-fade" />

      {/* Floating glow blobs */}
      <motion.div
        className="absolute -top-32 -left-24 h-[460px] w-[460px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(0,122,255,0.35) 0%, rgba(0,122,255,0) 65%)",
          filter: "blur(40px)",
        }}
        animate={{ y: [0, 30, 0], x: [0, 20, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-1/2 -right-32 h-[520px] w-[520px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(0,229,255,0.22) 0%, rgba(0,229,255,0) 65%)",
          filter: "blur(60px)",
        }}
        animate={{ y: [0, -40, 0], x: [0, -20, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-0 left-1/3 h-[420px] w-[420px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(125,90,255,0.18) 0%, rgba(125,90,255,0) 65%)",
          filter: "blur(50px)",
        }}
        animate={{ y: [0, -20, 0], x: [0, 30, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050505]" />
    </div>
  );
}
